import { render, staticRenderFns } from "./AddIslandModal.vue?vue&type=template&id=5d9a28b5&"
import script from "./AddIslandModal.vue?vue&type=script&lang=js&"
export * from "./AddIslandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports